export enum CompareOperator {
  BIGGER = '>',
  BIGGER_EQUALS = '>=',
  SMALLER = '<',
  SMALLER_EQUALS = '<=',
  EQUALS = '='
}
